import { render, staticRenderFns } from "./EdInputColor.vue?vue&type=template&id=e4b97e9a&"
import script from "./EdInputColor.vue?vue&type=script&lang=js&"
export * from "./EdInputColor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports